module.exports = __webpack_public_path__ + "media/beeps.b3dc7ad3.mp3";